<template>
  <div class="BlockList" v-show="floag">
    <div class="BlockList-W">
      <img
        class="imgs"
        src="../../../assets/pc/Login/close.png"
        @click="close"
      />
      <div class="logintit">Sign in</div>
      <div class="loginbox">
        <el-form ref="form" :model="form" :rules="rules">
          <div class="putext">
            <el-form-item prop="email">
              <el-input
                v-model="form.email"
                class="inpttext"
                placeholder="Email"
              ></el-input>
            </el-form-item>
          </div>

          <div class="putext">
            <el-form-item prop="password">
              <el-input
                v-model="form.password"
                class="inpttext"
                type="password"
                show-password
                placeholder="Password"
              ></el-input>
            </el-form-item>
          </div>
          <div class="forgot" @click="forgot">Forgot password?</div>
          <div class="logins" @click="login">OK</div>
          <div class="signup" @click="signup">Sign Up</div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { GetLogin } from "@/assets/server/api";
import { getSubStr } from "@/utils/utils";
export default {
  props: ["flog", "flogb"],
  data() {
    return {
      floag: false,
      floagb: false,
      xprlAddress:"",
      donationAddress:"",
      coinType:"",
      form: {
        email: "",
        password: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "email  is required",
            trigger: "change",
          },
          {
            type: "email",
            message: "Please enter a valid email address",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  components: {},
  created() {},
  mounted() {},
  watch: {
    deep: true,
    flog(val) {
      this.floag = val;
    },
    flogb(val) {
      console.log(val);
      this.floagb = val;
    },
  },
  methods: {
    close() {
      this.floag = false;
      this.$emit("loginflog", this.floag);
    },
    forgot(){
      this.floag = true;
      this.$emit("loginflog", this.floag);
      this.$emit("fflog", true)
    },
    signup() {
      // this.floag = false;
      this.floagb = true;
      // this.$emit("loginflog", this.floag);
      this.$emit("signups", this.floagb);
    },
    //点击进行账号登录
    async login() {
      //   console.log(this.form.code);
      // this.onVerifySuccess();
      // if (this.isVerify == false) {
      //   this.$message("Captcha is required");
      //   return false;
      // } else {
      //   console.log();
      //   this.onVerifySuccess();

      // }
      this.$refs.form.validate(async (success) => {
        //    if (this.validatePassword()) {
        //    console.log(this.form);
        if (success) {
          const params = {
            email: this.form.email,
            password: this.form.password,
          };
          const formData = new FormData();
          const item = params;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          let data = await GetLogin(formData);
         // console.log(data);
          if (data.code == 200) {
           // console.log("登录成功");
            this.floag = false;
            this.$router.push("/Index");
            this.$message("Login successful");
            this.$emit("email", getSubStr(this.form.email, 0, 4));
            this.$emit("isBind", data.result.isBindAddress);
            if(data.result.addressBind !==null){
            this.xprlAddress= data.result.addressBind.address;
          //  console.log(this.xprlAddress);
            this.donationAddress=data.result.addressBind.donationAddress;
            this.coinType=data.result.addressBind.coinType;
           // console.log(this.donationAddress);
            // localStorage.setItem("isBindAddress", 1);
            this.$emit("xprl", this.xprlAddress);
            this.$emit("donation", this.donationAddress);
            this.$emit("coinTypes", this.coinType);
            }
         
            // this.flog = false;
            localStorage.setItem("userId", data.result.userId);
            localStorage.setItem("email", data.result.email);
            localStorage.setItem("jwtToken", data.result.jwtToken);
            localStorage.setItem("isBindAddress", data.result.isBindAddress);
            if(data.result.addressBind !==null){
            localStorage.setItem("xprl",this.xprlAddress);
            localStorage.setItem("donation", this.donationAddress);
            localStorage.setItem("coinTypes", this.coinType);
            }
        

            // this.$emit("emails", data.result.email);
            // this.$router.push("/m/Ownership");
            // this.$router.push({
            //   path: "/m/Ownership",
            //   query: { userId: data.result.userId },
            // });
            // this.flog1 = true;
            // this.flog = false;
            // this.emails = data.result;
          } else {
            // this.$message(data.result);
            this.$message({
              message: data.result,
              type: "warning",
              customClass: "message-zindex",
            });
          }
        } else {
          // this.$message(" This field are not filled in ");
          this.$message({
            message: "This field are not filled in",
            type: "warning",
            customClass: "message-zindex",
          });
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.BlockList {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999999999;
  // background: red;
  width: 750px;
  height: 100%;
  overflow: auto;
  .BlockList-W {
    width: 650px;
    height: 656px;
    background: #202020;
    border-radius: 20px 20px 20px 20px;
    background: #151515;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    position: absolute;

    z-index: 0 !important;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .imgs {
      width: 36px;
      height: 36px;
      margin-left: 530px;
      margin-top: 20px;
    }
    .logintit {
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 36px;
      color: #ffffff;
      line-height: 33px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 10px;
    }
    .loginbox {
      width: 530px;
      margin: 0 auto;

      margin-top: 36px;
      .putext {
        width: 530px;
        /deep/.el-input__inner {
          border: none;
          background: #151515;
          border-bottom: 1px solid #5b5b5b;
          // padding-bottom: 10px;
          padding-left: 0px;
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 28px;
          color: #fff;
          width: 530px;
          border-radius: 0px !important;
          padding-left: 12px;
        }
        /deep/.el-input__inner::placeholder {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 28px;
          color: rgba(255, 255, 255, 0.3);
          width: 530px;
          border-radius: 0px !important;
        }
      }
      .forgot {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 28px;
        color: #ffffff;
        text-align: right;
       height: 16px;
       line-height: 16px;
      }
      .logins {
        width: 530px;
        height: 76px;
        background: #3cf6f0;
        border-radius: 162px 162px 162px 162px;

        text-align: center;
        line-height: 76px;
        margin-top: 50px;
        cursor: pointer;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 30px;
        color: #151515;
      }
      .signup {
        text-align: center;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 28px;
        color: #ffffff;
        margin-top: 24px;
        cursor: pointer;
      }
    }
  }
}
</style>
